import { dataDesktop } from 'dls-icons-data'
import { createIcon } from '../common'

const IconDesktop = /*#__PURE__*/createIcon(dataDesktop)
export default IconDesktop
